import { ISearchFilters, ISearchType } from "./SearchPage";
import { Dispatch, SetStateAction } from "react";
import { ResultsHOC } from "./ResultsHOC";
import { PaginationFooter } from "./PaginationFooter";
import PageSearchResult from "./PageSearchResult";
import styles from "./SearchPage.module.scss";

export function ExpandYourSearchInfoBox(props: {
  searchType: ISearchType;
  buttonText: string;
  onClick: () => void;
}) {
  const searchTypesDisplayMap: {
    [key in ISearchType]: string;
  } = {
    pages: "page",
    news_items: "news",
    event_items: "event",
    staff_members: "staff member",
    google_drive: "google drive file",
    files_and_folders: "file or folder",
  };

  return (
    <>
      <small>
        {`Not finding the ${searchTypesDisplayMap[props.searchType]} you're looking for? `}
        <button style={{ color: "#337ab7" }} onClick={props.onClick}>
          {props.buttonText}
        </button>
        .
      </small>
      <br />
    </>
  );
}

type IPageSearchResult = {
  title: string;
  headline: string;
  page_id: string;
  page_url: string;
  breadcrumbs: string;
};

export function PageSearchResults(props: {
  searchTypes: ISearchType[];
  results?: {
    data: IPageSearchResult[];
    meta: {
      total: number;
    };
  };
  filters: ISearchFilters;
  setFilters: Dispatch<SetStateAction<ISearchFilters>>;
  isValidating: boolean;
  searchTerm: string;
}) {
  const organizationsPage = props.filters["pages.page"];
  const pageSize = props.filters["pages.page_size"];
  const total = props.results?.meta.total || 0;
  const totalOrganizationsPages = Math.ceil(total / pageSize);

  return (
    <ResultsHOC
      isLoading={props.results?.data === undefined}
      isValidating={props.isValidating}
      resultsCount={total}
      searchTypes={props.searchTypes}
      thisComponentType={"pages"}
      searchTerm={props.searchTerm}
      noResultsString={"pages"}
    >
      {props.results?.data && (
        <ul className={styles.pageResultsContainer}>
          {props.results.data.map((result) => {
            return (
              <PageSearchResult
                key={result.page_id}
                title={result.title}
                id={result.page_id}
                url={result.page_url}
                content={result.headline}
                breadcrumbs={result.breadcrumbs}
              />
            );
          })}
        </ul>
      )}
      <PaginationFooter
        currentPage={organizationsPage}
        setPage={(page) =>
          props.setFilters((v) => ({
            ...v,
            "pages.page": page,
          }))
        }
        totalPages={totalOrganizationsPages}
      />
    </ResultsHOC>
  );
}
